export default __webpack_public_path__ + "static/media/weightlosswithfamily_1.f75ee840.jpg";